import { render, staticRenderFns } from "./DocumentsListFilters.vue?vue&type=template&id=4932a3d5&scoped=true&"
import script from "./DocumentsListFilters.vue?vue&type=script&lang=js&"
export * from "./DocumentsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListFilters.vue?vue&type=style&index=0&id=4932a3d5&lang=scss&scoped=true&"
import style1 from "./DocumentsListFilters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932a3d5",
  null
  
)

export default component.exports